import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_PTEM_EVALUACIONES = 'ALL_PTEM_EVALUACIONES';
export const LOADING_ALL_PTEM_EVALUACIONES = 'LOADING_ALL_PTEM_EVALUACIONES';
export const ACTIVO_PTEM_EVALUACIONES = 'ACTIVO_PTEM_EVALUACIONES';
export const LOADING_UPDATE_ESTATUS_PTEM_EVALUACIONES =
  'LOADING_UPDATE_ESTATUS_PTEM_EVALUACIONES';
export const PARAMS_PTEM_EVALUACIONES = 'PARAMS_PTEM_EVALUACIONES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  loadingUpdateEstatus: false,
  params: {},
};

export const ptemEvaluacionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PTEM_EVALUACIONES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_PTEM_EVALUACIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_PTEM_EVALUACIONES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case LOADING_UPDATE_ESTATUS_PTEM_EVALUACIONES:
      return {
        ...state,
        loadingUpdateEstatus: action.payload,
      };
    case PARAMS_PTEM_EVALUACIONES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
